// extracted by mini-css-extract-plugin
module.exports = {"info":"_a645881","infoUs":"_b3553a3"};